module.exports = __webpack_public_path__ + "media/referrals/referralKitNew-860e8bac.png";